import MacAddress from '../../../base/errors/airdome/MacAddress';

const macAddress: MacAddress = {
  unableToAdd: 'Unable to add device MAC address',
  unableToRemove: 'Unable to remove device MAC address'
};

export default macAddress;
